import React, { useState } from "react";
import "./CodeSnippet.css";

interface CodeSnippetProps {
  title: string;
  code: string;
}

const CodeSnippet: React.FC<CodeSnippetProps> = ({ title, code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="code-snippet">
      <div className="header">
        <h4>{title}</h4>
        <button onClick={handleCopy} className="copy-btn">
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
      <pre>
        <code>{code}</code>
      </pre>
    </div>
  );
};

export default CodeSnippet;
